import packageJson from '../../package.json';

export const environment = {
  production: true,
  title: 'Beta',
  apiUrl: 'https://api.devel.v2.ccclearningportal.org/v1/cca', //devel for testing purpose
  siteUrl: 'https://cca.beta.ccclearningportal.org',
  backgroundLogo: 'assets/images/CCC_logo_Welcome@2x.png',
  application: 'CCA',
  version: 'cca-' + packageJson.version,
  lstUpd: packageJson.lstUpd,
  logoutApps: ['cvp', 'admin', 'lp-content', 'coaching', '', 'https://manage.beta.collabcoach.org/cohorts']
};

export const OktaConfig = {
  clientId: '0oa44ohho4LfOz4Bt2p7',
  issuer: 'https://collabclasslh.okta.com/oauth2/aus563jbkhCtFhSMy2p7',
  redirectUri: environment.siteUrl + '/implicit/callback',
  grant_type: 'refresh_token',
  scope: ['openid', 'profile', 'email']
};
